import {httpConstants} from "../constants";
import {httpService} from "../utility/httpService";

export default {
    addBanner,
    getBannerList,
    updateBanner,
    deleteEntity,
    getGoldApi,
    updateGoldPrice,
    sendNotifOTP,
    sendBulkNotif,
}

async function addBanner(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.BANNER;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getBannerList() {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.BANNER_LIST;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function updateBanner(BASE_URL) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.BANNER;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), BASE_URL, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getGoldApi(BASE_URL) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.GOLD_API;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), BASE_URL, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function updateGoldPrice(BASE_URL) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.UPDATE_GOLD_API;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), BASE_URL, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function sendNotifOTP(BASE_URL) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.BULK_NOTIF_OTP_API;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), BASE_URL, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function sendBulkNotif(BASE_URL) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.BULK_NOTIF_API;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), BASE_URL, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function deleteEntity(entityName, id) {
    let url = httpConstants.BASE_URL + entityName + `?id=${id}`;
    return httpService(httpConstants.METHOD_TYPE.DELETE, getHeaders(), {}, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}


function getHeaders() {
    return {'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true}
}
